import { apiClient } from './client';

/**
 * 埋点上报（M9）
 * 事件名：trial_start / trial_complete / register / diagnosis_start /
 *         diagnosis_complete / report_view / pdf_download / share / lead_submit
 */
export function track(event: string, payload: Record<string, unknown> = {}): void {
  apiClient.post('/events', { event, ...payload }).catch(() => {
    // 埋点失败不阻塞业务
  });
}
